import * as React from 'react';
import * as intl from 'react-intl-universal';
import { CameraOutlined } from '@ant-design/icons';
import ModalHelper from 'common/components/ModalHelper';
import Cropper from './Cropper';
import formatter from 'common/utils/formatter';

export {
    Cropper
};

export default class ImageCropper extends React.Component<any> {
    openClickHandler =async () => {
        const { url, onSubmit } = this.props;
        await ModalHelper.show({
            Dialog: Cropper,
            config: {
                data: (url && formatter.contact.relativeUrl(url.aws)) || window.config.img_file(`/images/icons/avatar.png`),
                onOK: onSubmit
            }
        });
    };

    render() {
        return (
            <span className='Cropper'>
                <span className='Avatar-wrapper' onClick={this.openClickHandler}>
                    {this.props.children || <a>{intl.get('Global.AvatarCrop')}</a>}
                    <span className='Avatar-wrapper-float'>
                        <CameraOutlined style={{color: "#ffffff"}}/>
                    </span>
                </span>
            </span>
        );
    }
}
